module.exports = __webpack_public_path__ + "static/img/business71.9bf5499.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business71.png
// module id = QA9H
// module chunks = 9